/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { useTranslation } from 'react-i18next';

export default function SurveyDialog(props) {
  const { dialogSurveySubmission } = props;
  const { t } = useTranslation();

  const openInNewTab = () => {
    window.open('https://forms.office.com/e/fTZ2bzgv8N?origin=lprLink', '_blank', 'noopener,noreferrer');
    dialogSurveySubmission.close();
  };

  return (
    <div>
      <Dialog open={dialogSurveySubmission.isOpen} fullWidth maxWidth="lg">
        <DialogTitle>
          <Typography component="h2" variant="h2">
            {t('survey.messages.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" component="p" gutterBottom style={{ paddingTop: '2rem' }}>
            {t('survey.messages.text')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button id="close" color="default" variant="contained" onClick={dialogSurveySubmission.close}>
            {t('survey.messages.button.no')}
          </Button>
          <Button id="open" color="primary" variant="contained" onClick={openInNewTab}>
            {t('survey.messages.button.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
